export class FormalizeCompany {
    companyId: string = null;
    companyName: string = null;
    clientOrBUId: string = null;
    clientOrBUName: string = null;

    constructor(companyId, companyName, clientOrBUId, clientOrBUName) {
        this.companyId = companyId;
        this.companyName = companyName;
        this.clientOrBUId = clientOrBUId;
        this.clientOrBUName = clientOrBUName;
    }
}

export class FormalizeJobMatch {
    jobMatchId: string = null;
    jobId: string = null;
    requisitionId: string = null;
    requisitionName: string = null;

    constructor(jobMatchId, jobId, requisitionId, requisitionName) {
        this.jobMatchId = jobMatchId;
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
}

export class FormalizeRequisition {
    jobId: string = null;
    requisitionId: string = null;
    requisitionName: string = null;

    constructor(jobId, requisitionId, requisitionName) {
        this.jobId = jobId;
        this.requisitionId = requisitionId;
        this.requisitionName = requisitionName;
    }
}

export class FormalizeCandidate {
    candidateId: string = null;
    firstName: string = null;
    lastName: string = null;

    constructor(candidateId, firstName, lastName) {
        this.candidateId = candidateId;
        this.firstName = firstName;
        this.lastName = lastName;
    }
}

export class FormalizeUser {
    userId: string = null;
    firstName: string = null;
    lastName: string = null;
    email: string = null;

    constructor(userId, firstName, lastName, email) {
        this.userId = userId;
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
    }
}

export class FormalizePayload {
    activityType: string = 'TEXT_FORMALIZATION';
    duration: number = null;
    dateRange: { startDate: string; endDate: string } = { startDate: null, endDate: null };
    sourceScreen: string = null;
    externalNote: string = null;
    noteId: string = null;
    company: FormalizeCompany = null;
    jobMatch: FormalizeJobMatch = null;
    requisition: FormalizeRequisition = null;
    candidate: FormalizeCandidate = null;
    user: FormalizeUser = null;
    originalText: string = null;
    formalizedText: string = null;
    mode: string = 'TEXT';
    tone: string = null;
    savedNote: string = null;

    constructor(data?: Partial<FormalizePayload>) {
        if (data) { Object.assign(this, data); }
    }
}
